import * as angular from 'angular';
import * as _ from 'lodash';
import { apsViewModels } from "../../shared/dto/APS.ViewModels";
import CommoditiesServiceName, { CommoditiesService } from "../../services/batches/commodities.service";
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import NewGuidServiceName, { NewGuidService } from "../../services/utility/newguid.service";
import { apsCommands } from "../../shared/dto/aps.commands";
import template from './updateCommodityPercentage.tpl.html';

let requires = [CommoditiesServiceName, NotifyServiceName, LoaderServiceName, NewGuidServiceName];

interface UpdateCommodityPercentageController {
  save(): void;
  cancel(): void;
}

export interface UpdateCommodityPercentageParams {
  instance: apsViewModels.CommodityPercentageItem;
  allCommodities: apsViewModels.CommodityItem[];
}

export function openUpdateCommodityPercentage(data: UpdateCommodityPercentageParams,
  $modal: mm.foundation.modal): angular.IPromise<apsViewModels.CommodityPercentageItem> {
  return $modal.open({
    template: template,
    controller: 'UpdateCommodityPrcntCtrl as vm',
    resolve: {
      data: () => data
    }
  }).result;
}

class UpdateCommodityPrcntCtrl implements UpdateCommodityPercentageController {
  instance: apsViewModels.CommodityPercentageItem;
  form: angular.IFormController;
  allCommodities: apsViewModels.CommodityItem[];
  primaryCommodity: apsViewModels.CommodityItem;
  secondaryCommodity: apsViewModels.CommodityItem;
  commodityName: string;

  private $modalInstance: mm.foundation.modalInstance;
  private commoditiesService: CommoditiesService;
  private notifyService: NotifyService;
  private loaderService: LoaderService;
  private newId: string;

  constructor(
    $modalInstance: mm.foundation.modalInstance,
    commoditiesService: CommoditiesService,
    data: UpdateCommodityPercentageParams,
    notifyService: NotifyService,
    loaderService: LoaderService
  ) {
    this.$modalInstance = $modalInstance;
    this.commoditiesService = commoditiesService;
    this.notifyService = notifyService;
    this.loaderService = loaderService;
    this.allCommodities = { ...data.allCommodities };
    this.instance = { ...data.instance };
    this.commodityName = _.find(this.allCommodities, x => x.id === this.instance.commodityId).name
    this.primaryCommodity = _.find(this.allCommodities, x => x.id === this.instance.primaryCommodityId);
    this.secondaryCommodity = _.find(this.allCommodities, x => x.id === this.instance.secondaryCommodityId);
    // this.loaderService.loadingPromise(newGuidService.getNewGuid('Commodity')
    //   .then(id => this.newId = id));
  }

  save(): void {
    if (this.form.$invalid) {
      return;
    }

    if (this.primaryCommodity.id === this.secondaryCommodity.id) {
      this.notifyService.error('Primary Commodity and Secondary Commodity cannot be the same');
      return;
    }

    if (this.instance.primaryPercentage + this.instance.secondaryPercentage != 100) {
      this.notifyService.error('Percentages of Primary and Secondary should be equal to 100');
      return;
    }
    let command = <apsCommands.UpdateCommodityPercentage>{
      ...this.instance
    };

    command.primaryCommodityId = this.primaryCommodity.id;
    command.secondaryCommodityId = this.secondaryCommodity.id;

    this.loaderService.loadingPromise(this.commoditiesService.updateCommodityPercentage(command)
      .then(() => {
        this.instance.primaryCommodityId = this.primaryCommodity.id;
        this.instance.secondaryCommodityId = this.secondaryCommodity.id;
        this.$modalInstance.close(this.instance);
      }, this.notifyService.handleApiErrors)
    );
  }

  cancel(): void {
    this.$modalInstance.close();
  }
}

export default angular.module('aps.controller.updateCommodityPercentage', requires)
  .controller('UpdateCommodityPrcntCtrl', UpdateCommodityPrcntCtrl)
  .name;


// WEBPACK FOOTER //
// ./src/app/controllers/batches/updateCommodityPercentage.controller.ts